// This code is same as login-callback from @okta/react. Somehow this code wasn't working
// even after bumping the version. Maybe an issue with my system (node_modules). Will check with
// mac and change accordingly.
import { OktaMetaData } from 'module/api/account/types';
import { CognitoAPI } from 'module/authentication/api/cognito';
import { useQueryParams } from 'module/helpers/location-query-params';
import { useOktaAuth } from '@okta/okta-react';
import React from 'react';

export type OnAuthResumeFunction = () => void;

interface LoginCallbackProps {
  errorComponent?: React.ComponentType<
    React.PropsWithChildren<{ error: Error }>
  >;
  onAuthResume?: OnAuthResumeFunction;
  loadingElement?: React.ReactElement;
  oktaMetaData?: OktaMetaData;
  onUserAuthenticatedInOkta: VoidFunction;
  postLoginRedirectUrl: string;
}
const OktaError = ({ error }) => {
  if (error.name && error.message) {
    return (
      <p>
        {error.name}: {error.message}
      </p>
    );
  }

  return <p>{error.toString()}</p>;
};

export const LoginCallback: React.FC<
  React.PropsWithChildren<LoginCallbackProps>
> = ({
  errorComponent,
  loadingElement = null,
  onAuthResume,
  oktaMetaData,
  onUserAuthenticatedInOkta,
  postLoginRedirectUrl,
}) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [callbackError, setCallbackError] = React.useState(null);
  const params = useQueryParams();
  const code = params.get('code');
  const codeVerifier = sessionStorage.getItem('codeVerifier');

  const ErrorReporter = errorComponent || OktaError;

  React.useEffect(() => {
    if (codeVerifier) {
      const issuerDomain = oktaMetaData?.issuerDomain;
      const clientId = oktaMetaData?.clientId;

      if (code && codeVerifier && issuerDomain) {
        CognitoAPI.loginWithCognitoSSO(
          issuerDomain,
          code,
          `${window.location.origin}/implicit/callback`,
          codeVerifier,
          clientId,
        ).then((res: any) => {
          const { access_token } = res;

          window.location.href = `${postLoginRedirectUrl}?token=${access_token}&cognito=true`;
        });
      }
    } else {
      if (onAuthResume) {
        onAuthResume();

        return;
      }
      oktaAuth
        .handleLoginRedirect()
        .then(() => {
          if (authState?.isAuthenticated) {
            onUserAuthenticatedInOkta();
          }
        })
        .catch((e) => {
          setCallbackError(e);
        });
    }
  }, [
    oktaAuth,
    onAuthResume,
    authState,
    codeVerifier,
    code,
    oktaMetaData?.issuerDomain,
    onUserAuthenticatedInOkta,
    postLoginRedirectUrl,
    oktaMetaData?.clientId,
  ]);

  const authError = authState?.error;
  const displayError = callbackError || authError;

  if (displayError) {
    return <ErrorReporter error={displayError} />;
  }

  return loadingElement;
};
